var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"underline cursor-pointer",on:{"click":function($event){return _vm.$router.push(`/admin/articles/${_vm.data._id}`)}}},[_vm._v(_vm._s(_vm.data.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }